export const environment = {
  production: true,
  apiPath: 'api',
  damping: 0.2,
  logging: true,
  wsUrl: 'https://prod.shiveapp.com/ws/tracker/',
};
